module.exports = __webpack_public_path__ + "static/media/instagram.5b23a837.svg";